import { ProductContent } from '@common'
import dynamic from 'next/dynamic'

import { useProductImage } from '@/features/storefronts/_storeBase/card/utils'
import { ImageWithFallback } from '@/features/storefronts/_storeBase/imageWithFallback/ImageWithFallback'
import { useTranslatable } from '@/localization/useTranslatable'

import { Badge } from './Badge'

import styles from './RoyaleItem.module.scss'

type Props = {
  content: ProductContent
}

const AnimatedImageWithFallbackNoSSR = dynamic<{
  animationSrc: string
  fallbackImage: string
  safariAnimationSrc?: string | undefined
}>(
  () =>
    import('@/features/storefronts/_storeBase/imageWithFallback/AnimatedImageWithFallback').then(
      (mod) => mod.AnimatedImageWithFallback,
    ),
  { ssr: false },
)

const ProductImage = ({ content }: Props) => {
  const translatable = useTranslatable()
  const { imageSrc, isAnimated, animatedSrc, safariAnimatedSrc } = useProductImage({
    game: 'clashroyale',
    productId: content.product.id,
  })

  if (isAnimated) {
    return (
      <div className={styles.ProductImage}>
        <AnimatedImageWithFallbackNoSSR
          animationSrc={animatedSrc}
          fallbackImage={imageSrc}
          safariAnimationSrc={safariAnimatedSrc}
        />
      </div>
    )
  }

  return (
    <div className={styles.ProductImage}>
      <ImageWithFallback productImage={imageSrc} title={translatable(content.product.title)} />
    </div>
  )
}

export const RoyaleItem = ({ content }: Props) => {
  return (
    <div className={styles.Card}>
      <ProductImage content={content} />
      <div className={styles.Footer}>
        <Badge amount={content.amount} />
      </div>
    </div>
  )
}
